
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.19 94.19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"34.76","fill":"none","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M58.35 61.62a14.94 14.94 0 01-8.24 2.32c-4.48 0-8.46-1.71-11.23-4.92-2.1-2.32-3.49-5.53-3.98-9.52h-3.43v-2.71h3.15v-.83c0-.89.06-1.72.11-2.49h-3.26V40.7h3.65a17.48 17.48 0 014.54-9.35 14.6 14.6 0 0110.96-4.59c3.26 0 5.81.94 7.36 1.77l-1.11 3.65a12.74 12.74 0 00-6.2-1.55 9.63 9.63 0 00-7.3 3.04c-1.66 1.6-2.77 4.09-3.32 7.03h15.44v2.77H39.54c-.06.72-.11 1.55-.11 2.32v1h16.05v2.71H39.81c.44 3.21 1.55 5.59 3.04 7.25a10.51 10.51 0 007.8 3.21c2.93 0 5.48-1.11 6.75-1.83l.95 3.49z","fill":"#fff"}})])
          )
        }
      }
    